import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import './image.css'

const Image = (props) => (
  <div className={classnames({
    'content content--image': true,
    [props.className]: props.className
  })}>
    <img src={props.src} alt={props.alt} />
  </div>
)

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string
}

export default Image



// WEBPACK FOOTER //
// ./src/components/Page/Content/Image/index.js